$shm_ba_filter_section $mol_view
	title \
	table null
	filter? *
	search_query? \
	count <= filter_count null
	tools /
		<= Search $mol_search
			hint \Найти
			query? <=> search_query? \
	title_content /
		<= title
	content /
		<= Filter $shm_ba_filter_list
			table <= table null
			filter? <=> filter? *
			search_query? <=> search_query? \
	sub <= section_rows /
	Title $mol_view
		sub /
			<= Expand $mol_check_expand
				checked? <=> expanded? true
				expandable true
			<= Label $mol_view
				sub /
					^ title_content /
						<= title
					<= Count $mol_view
						sub /
							<= count_label \
			<= Tools $mol_view
				sub <= tools
